export default __webpack_public_path__ + "static/media/SKIN-INFECTION.1dbccb6f.png";